<template>
  <div class="template">
    <div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会议主题">
          <el-input v-model="searchForm.subject" size="small" clearable placeholder="会议主题" />
        </el-form-item>
        <el-form-item label="会议类型">
          <el-select v-model="searchForm.type_id" size="small" clearable placeholder="请选择">
            <el-option v-for="(tp, index) in meetingTypeList" :key="index" :label="tp.type_name" :value="tp.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="会议时间">
          <el-date-picker
            v-model="time"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
        </el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" style="margin-top:5px" @click="searchBtn">查询
        </el-button>
        <el-button size="mini" type="success" icon="el-icon-plus" style="margin-top:5px" @click="addBtn">添加模板
        </el-button>
      </el-form>
    </div>

    <div>
      <el-card v-for="(tp, index) in templateList" :key="index" class="box-card">
        <div slot="header" class="clearfix">
          <span style="display: inline-block; max-width: 320px">{{ tp.meeting_subject }}</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="deleteBtn(tp.id,tp.meeting_subject)">删除
          </el-button>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="createMeetingVisible=true;createBtn(tp.id,tp.meeting_subject)">预约&nbsp;&nbsp;
          </el-button>
          <el-button style="float: right; padding: 3px 0" type="text" @click="editBtn(tp.id)">编辑
          </el-button>
        </div>
        <div class="text item">
          <p>模板循环周期：{{ tp.start_date }} 至 {{ tp.end_date }}</p>
          <p>重复方式：<span v-show="tp.repeat_type==='0'">每天</span> <span v-show="tp.repeat_type==='1'">每周</span><span
            v-show="tp.repeat_type==='2'">每月</span>
            <span v-show="tp.repeat_type==='1'">(
              <span v-for="(mm,index1) in tp.repeat_rule" :key="index1">周{{ mm }} </span>)
            </span>
            <span v-show="tp.repeat_type==='2'">(
              <span v-for="(mm,index2) in tp.repeat_rule" :key="index2">{{ mm }}号、</span>)
            </span>
          </p>
          <p>模板类型：{{ tp.template_type === 0?'早晚会':'大杂会' }}</p>
          <p v-if="tp.template_type===1">会议时间：{{ tp.start_time }}-{{ tp.end_time }}</p>
          <p v-if="tp.template_type===0">早会时间：{{ tp.start_time }}-{{ tp.end_time }}</p>
          <p v-if="tp.template_type===0">晚会时间：{{ tp.night_start_time }}-{{ tp.night_end_time }}</p>
          <p>召集人：{{ tp.extra.convenor.name }} &nbsp;&nbsp;主持人：{{ tp.extra.host.name }}&nbsp;&nbsp;
          会议秘书：{{ tp.extra.secretary.name }}</p>
          <p />
          <p>参会人员：<span v-for="(att,index3) in tp.extra.attendees" :key="index3">{{ att.name }},</span> </p>
          <p>提醒时间：开会前{{ tp.reminder }}分钟提醒</p>
        </div>
      </el-card>
    </div>
    <el-card
      v-loading="waiting"
      v-if="waiting===true"
      style="height:200px"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0,0,0, 0.6)" />
    <el-card v-if="total===0 && waiting === false" style="height:200px">
      <div style="line-height: 160px; text-align:center">无数据</div>
    </el-card>
    <div style="text-align: center;padding:30px 0 50px 0;clear: both;">
      <el-pagination
        :current-page="page"
        :page-sizes="[6, 12, 30, 50]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <!-- 添加/编辑 模板组件 -->
    <edit-drawer
      :editVisible="addDrawer"
      :editId="editId"
      :meetingTypeList="meetingTypeList"
      :departmentList="departmentList"
      :userList="list"
      :departTree="nodews"
      @editSuccess="editSuccess"
      @closeDrawer="closeDrawer">
    </edit-drawer>

    <el-dialog :visible.sync="createMeetingVisible" :before-close="closePop" title="会议预约" width="30%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="主题">
          <el-input v-model="meeting_subject" disabled />
        </el-form-item>
        <el-form-item label="选择会议室" prop="room_id">
          <el-select v-model="ruleForm.room_id" filterable remote reserve-keyword>
            <el-option v-for="(item,index) in roomList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePop">取 消</el-button>
        <el-button type="primary" size="small" :loading="loading" @click="submitRoom('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'// 获取创建人信息
import { searchTemplate, searchRoom, createMeeting, deleteTemplate } from '@/api/meetingTemplate'
import { searchType } from '@/api/meetingType'
import { gituser, gitusers } from '@/api/user'
import { getAllSecretary } from '../../api/secretary'
import editDrawer from './components/editDrawer'

export default {
  components: {
    'edit-drawer': editDrawer
  },
  data() {
    return {
      list: [],
      waiting: false,
      editId: null,
      addDrawer: false,
      loading: false,
      createMeetingVisible: false, // 会议预约选择
      roomList: [],
      searchForm: {
        subject: '',
        type_id: '',
        start_date: '',
        end_date: ''
      },
      time: '', // 会议开始结束日期数组
      departmentList: [], // 所有部门列表
      rules: {
        room_id: [
          { required: true, message: '请选择一个会议室', trigger: 'change' }
        ]
      },
      meetingTypeList: [],
      templateList: [], // 模板列表
      nodews: [],
      total: 0,
      page: 1,
      page_size: 6,
      ruleForm: { // 预约会议室参数
        room_id: '', // 预约，选中会议室
        template_id: '', // 预约，模板id
        room_id_first: ''
      },
      meeting_subject: '' // 页面文字
    }
  },
  computed: {
    ...mapGetters(['roles', 'name', 'userId'])
  },
  created() {
    this.getMeetingType()
    this.searchBtn()
    this.getRoom()
  },
  mounted() {
    gituser().then(response => {
      const dict_str = response.data
      this.read_json_only(dict_str)
    }).catch(err => {
      console.log(err)
    })
    const data = {
      departmentId: 0
    }
    this.getuserlist(data, 0)
    this.getDepartment()
  },
  methods: {
    closeDrawer() {
      this.addDrawer = false
    },
    editSuccess() {
      this.addDrawer = false
      this.searchBtn()
      this.successMsg()
    },
    getDepartment() {
      const params = {
        is_available: 1,
        page: 1,
        page_size: 10000
      }
      getAllSecretary(params).then(res => {
        console.log(res)
        if (res.code === 'success' && res.data && res.data.secretary) {
          this.departmentList = res.data.secretary
        } else {
          this.departmentList = []
        }
      })
    },
    closePop() {
      this.$refs.ruleForm.resetFields()
      this.createMeetingVisible = false
    },
    // 会议类型
    getMeetingType() {
      searchType().then(res => {
        this.meetingTypeList = res.code === 'success' ? res.data.types : []
      }).catch()
    },
    getTemplate(data) {
      this.waiting = true
      this.templateList = []
      searchTemplate(data).then(res => {
        this.waiting = false
        if (res.code === 'success') {
          this.templateList = res.data.templates
          this.total = res.data.pagination.total
        } else {
          this.templateList = []
        }
      }).catch(err => {
        console.log(err)
        this.waiting = false
      })
    },
    getRoom() {
      searchRoom({ page: 1, page_size: 1000, room_status: 1 }).then(res => {
        if (res.code === 'success') {
          this.roomList = res.data.rooms
          this.roomList.forEach(item => {
            if (item.id === 19) {
              this.ruleForm.room_id = item.name
              this.ruleForm.room_id_first = item.id
            }
          })
        } else {
          this.roomList = []
        }
      })
    },
    createBtn(id, meeting_subject) {
      this.ruleForm.template_id = id
      this.meeting_subject = meeting_subject
    },
    submitRoom(formName) { // 预约会议室内
      this.$refs[formName].validate((valid) => {
        let id = null
        if (!Number(this.ruleForm.room_id)) {
          id = this.ruleForm.room_id_first
        }
        if (valid) {
          const data = {
            template_id: this.ruleForm.template_id,
            room_id: id || this.ruleForm.room_id
          }
          this.loading = true
          createMeeting(data).then(res => {
            this.loading = false
            let htmlsuc = ''
            let htmlfail = ''
            let html = ''
            if (res.data.success) {
              for (const i in res.data.success) {
                htmlsuc = htmlsuc + "<p><i class='el-icon-success'></i>" + res.data.success[i] + ';</p>'
              }
            }
            if (res.data.fail) {
              for (const i in res.data.fail) {
                htmlfail = htmlfail + "<p><i class='el-icon-error'></i>" + res.data.fail[i] + ';</p>'
              }
            }
            html = htmlsuc + htmlfail
            this.$notify({
              title: '预约提示',
              dangerouslyUseHTMLString: true,
              message: html,
              duration: 0,
              customClass: 'alertClass'
            })
            if (res.code === 'success') {
              this.createMeetingVisible = false
              this.$refs.ruleForm.resetFields()
            } else {
              this.errMsg()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    deleteBtn(id, name) {
      this.$confirm('确定要删除主题为《 ' + name + '》的模板吗?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTemplate(id).then(res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getTemplate()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 点击编辑获取模板数据by-id
    editBtn(id) {
      this.editId = id
      this.addDrawer = true
    },
    // 参会人相关
    getuserlist(data, type) {
      gitusers(data)
        .then(response => {
          if (type === 0) {
            this.list = response.data
          }
          console.log(response)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 参会人相关
    read_json_only(dict_str) {
      for (const i in dict_str) {
        dict_str[i].Name = dict_str[i].udName
        if (typeof dict_str[i].children === 'object') {
          this.read_json_only(dict_str[i].children)
        }
      }
      this.nodews = dict_str
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    },
    addBtn() {
      this.addDrawer = true
      this.needDepart = false
      this.editId = null
    },
    // 搜索
    searchBtn() {
      this.handleData(1, this.page_size, 1)
    },
    // 分页
    handleSizeChange(val) {
      const obj = JSON.parse(JSON.stringify(this.searchForm))
      obj.page = 1
      if (this.time) {
        obj.start_date = this.time[0]
        obj.end_date = this.time[1]
      }
      obj.page_size = val
      this.page_size = val
      this.getTemplate(obj)
    },
    handleCurrentChange(val) {
      this.handleData(val, this.page_size, val)
    },
    handleData(objPage, objPageSize, page) {
      const obj = JSON.parse(JSON.stringify(this.searchForm))
      if (this.time) {
        obj.start_date = this.time[0]
        obj.end_date = this.time[1]
      }
      obj.page = objPage
      obj.page_size = objPageSize
      this.page = page
      this.getTemplate(obj)
    }
  }
}
</script>
<style scoped>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 16px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 500px;
    height: 330px;
    overflow: auto;
    float: left;
    margin: 10px 10px 0px 0;
  }

  .demo-drawer__content {
    padding: 10px 30px 100px 20px;

    height: 100vh;
    overflow: auto;
  }

  .demo-drawer__footer {
    text-align: center;
  }

  .demo-drawer__footer .el-button {
    width: 30%;
  }

  .el-date-editor--datetime {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-icon-circle-plus-outline {
    font-size: 30px;
    color: rgb(182, 160, 139);
    cursor: pointer;
  }
  .demo-drawer__footer {
    text-align: center;
        height: 17%;
  }
</style>

<style>
  .template .el-card__body {
    padding: 5px 15px;
  }

  .alertClass {
    width: 500px !important;
  }
</style>
